"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AnalyticsContext", {
    enumerable: true,
    get: function() {
        return AnalyticsContext;
    }
});
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var AnalyticsContext = _react.default.createContext({
    identify: function() {
        return null;
    },
    group: function() {
        return null;
    },
    page: function() {
        return null;
    },
    track: function() {
        return null;
    },
    user: function() {
        return {
            anonymousId: ''
        };
    },
    reset: function() {
        return null;
    },
    revenue: function() {
        return null;
    }
});
